import React from 'react';

function CompanyItem({ company }) {
  if (company) {
    return (
      <div>
        <div className="col s6">
          <label htmlFor="company_id">Company</label>
          <p>Name: {company.companyName}</p>
          <p>Id: {company.id}</p>
          <img className="banner-image" src={company.bannerUrl} alt={'bannerUrl'} />
        </div>
      </div>
    );
  } else {
    return <div />;
  }
}

export default CompanyItem;
